'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {evlCriterionModel} from './evlcriterionmodel.js';

export class evlCriteriaGroupModel extends ngDepModel
{
	criteria = {};
	type = 'group';
	hasParent = false;
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	beforeSetup(data){
		if(typeof(data.criteria) !== 'undefined'){
			for(let id in data.criteria){
				data.criteria[id] = new evlCriterionModel(data.criteria[id], this._services.$filter, this._services.jsDataService);
				data.criteria[id].hasParent = true;
			}
		}
	}
	
	afterSetup(){
		this.countTotal();
	}
	
	countTotal(){
		this.threshold = 0;
		this.max = 0;
		this.score = 0;
		for(let id in this.criteria){
			this.threshold += this.criteria[id].getThreshold();
			this.max += this.criteria[id].getMax();
			this.score += this.criteria[id].getScore();
		}
	}
	
	getMax(){
		this.countTotal();
		if(isNaN(this.max) || !this.max){
			return 0;
		}
		return parseInt(this.max);
	}
	
	getThreshold(){
		this.countTotal();
		if(isNaN(this.threshold) || !this.threshold){
			return 0;
		}
		return parseInt(this.threshold);
	}
	
	getScore(){
		this.countTotal();
		if(isNaN(this.score) || !this.score){
			return 0;
		}
		return Number(this.score.toFixed(2));
//		return parseInt(this.score);
	}
	
	isTooLow(){
		return (this.getScore() < this.getThreshold());
	}
	
	isTooHigh(){
		return (this.getScore() > this.getMax());
	}
	
	getData(){
		let obj = Object.assign({}, angular.copy(this));
		if(typeof(obj.criteria) !== 'undefined'){
			for(let id in obj.criteria){
				if(obj.criteria[id] instanceof evlCriterionModel){
					obj.criteria[id] = obj.criteria[id].getData();
				}
			}
		}
		delete obj._services;
		return obj;
	}
	
	isAnyTooHigh(){
		if(this.isTooHigh()){
			return true;
		}
		for(let id in this.criteria){
			if(this.criteria[id].isTooHigh()){
				return true;
			}
		}
		return false;
	}
}